(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (() => {

    function alignProductCards() {

      document.querySelectorAll('product-card').forEach(card => {

        const content = card.querySelector('.product-card__content');

        const extra = card.querySelector('.rejsell-card-extra');

        if (!content || !extra) return;

        card.classList.add('rejsell-unified-card');

        const price = Array.from(content.children).find(child =>

          child.matches('product-price, .price') || child.querySelector('.price')

        );

        if (extra.parentElement !== content || (price && extra.nextElementSibling !== price)) {

          content.insertBefore(extra, price || null);

        }

        const source = card.querySelector('.rejsell-global-card-source');

        if (source && !source.children.length) source.hidden = true;

      });

    }

    let scheduled = false;

    function schedule() {

      if (scheduled) return;

      scheduled = true;

      requestAnimationFrame(() => { scheduled = false; alignProductCards(); });

    }

    function start() {

      alignProductCards();

      const main = document.querySelector('#MainContent');

      if (main && !window.rejsellGlobalCardObserver) {

        window.rejsellGlobalCardObserver = new MutationObserver(schedule);

        window.rejsellGlobalCardObserver.observe(main, { childList: true, subtree: true });

      }

    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });

    else start();

    document.addEventListener('shopify:section:load', schedule);

  })();



  (() => {

    if (window.rejsellFeatureDisclosureInstalled) return;

    window.rejsellFeatureDisclosureInstalled = true;

    let nextId = 0;

    document.addEventListener('click', event => {

      if (!(event.target instanceof Element)) return;

      const button = event.target.closest('.rejsell-feature-toggle');

      if (!button) return;

      const panel = button.nextElementSibling;

      if (!panel?.classList.contains('rejsell-feature-panel')) return;

      event.preventDefault();

      event.stopPropagation();

      if (!panel.id) {

        do { nextId++; } while (document.getElementById('rejsell-feature-panel-' + nextId));

        panel.id = 'rejsell-feature-panel-' + nextId;

      }

      button.setAttribute('aria-controls', panel.id);

      const expanded = button.getAttribute('aria-expanded') !== 'true';

      button.setAttribute('aria-expanded', String(expanded));

      panel.setAttribute('aria-hidden', String(!expanded));

      panel.classList.toggle('is-open', expanded);

    }, true);

    document.addEventListener('keydown', event => {

      if (event.target instanceof Element && event.target.closest('.rejsell-feature-toggle') &&

          (event.key === 'Enter' || event.key === ' ')) event.stopPropagation();

    }, true);

  })();
  } catch(e) { console.error(e); }
})();

})();
